import { useState, useCallback, useEffect, useRef } from 'react';
import { getJuthoorLands } from '@/lib/api/juthoor';
import type { JuthoorLand } from '@/types/juthoor';

const MOCK_LANDS: JuthoorLand[] = [
  {
    id: 1, landId: 101, landName: 'أرض الواحة — العُلا', status: 'active',
    firstname: 'سعد', lastname: 'الغامدي',
    polygon: { points: [[38.12, 26.58], [38.15, 26.58], [38.15, 26.55], [38.12, 26.55]] },
  },
  {
    id: 2, landId: 102, landName: 'مزرعة النخيل — المدينة المنورة', status: 'active',
    firstname: 'فهد', lastname: 'العتيبي',
    polygon: { points: [[39.61, 24.47], [39.65, 24.47], [39.65, 24.44], [39.61, 24.44]] },
  },
  {
    id: 3, landId: 103, landName: 'حديقة الأمير — الرياض', status: 'active',
    firstname: 'عبدالله', lastname: 'الدوسري',
    polygon: { points: [[46.67, 24.68], [46.71, 24.68], [46.71, 24.65], [46.67, 24.65]] },
  },
  {
    id: 4, landId: 104, landName: 'غابة السرو — أبها', status: 'active',
    firstname: 'خالد', lastname: 'القحطاني',
    polygon: { points: [[42.50, 18.21], [42.54, 18.21], [42.54, 18.18], [42.50, 18.18]] },
  },
  {
    id: 5, landId: 105, landName: 'أرض الأثل — تبوك', status: 'active',
    firstname: 'محمد', lastname: 'الحربي',
    polygon: { points: [[36.55, 28.38], [36.59, 28.38], [36.59, 28.35], [36.55, 28.35]] },
  },
];

export function useJuthoorLands(): {
  data: JuthoorLand[];
  loading: boolean;
  error: string | null;
} {
  const [data, setData] = useState<JuthoorLand[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const mountedRef = useRef(true);

  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  }, []);

  const fetchLands = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await getJuthoorLands();
      if (!mountedRef.current) return;
      if (response.success && response.data && response.data.length > 0) {
        setData(response.data);
      } else {
        setData(MOCK_LANDS);
      }
    } catch {
      if (!mountedRef.current) return;
      setData(MOCK_LANDS);
    } finally {
      if (mountedRef.current) setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchLands();
  }, [fetchLands]);

  return { data, loading, error };
}
